module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-header color-1-100"
  }, [_c('h1', [_c('span', [(_vm.canEditRecommendedEmails || _vm.canEditOptionalEmails) ? [_vm._v("\n              Edit email preferences\n            ")] : [_vm._v("\n              Email preferences\n            ")]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "admin-breadcrumbs"
  }, [_c('router-link', {
    staticClass: "profile profile-custom background-1-20 color-2-100",
    attrs: {
      "to": {
        name: 'profile'
      }
    }
  }, [_c('span', {
    staticClass: "profile-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 11.096 14.417"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 11.096 14.417",
      "xml:space": "preserve"
    }
  }, [_c('circle', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_497_",
      "cx": "5.548",
      "cy": "3.75",
      "r": "3.75"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_496_",
      "d": "M1.002,14.417c-0.619,0-1.087-0.558-0.989-1.17c0.442-2.766,2.492-4.455,5.535-4.455\n                s5.093,1.69,5.535,4.455c0.098,0.611-0.37,1.17-0.989,1.17H1.002z"
    }
  })])]), _vm._v("\n          Go to my profile\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-block"
  }, [_c('div', {
    staticClass: "content-right-section anchors"
  }, [_c('div', {
    staticClass: "sticky-anchors background-1-40-before",
    attrs: {
      "tabindex": "-1"
    }
  }, [(_vm.emails && _vm.emails['required']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 data",
    class: [{
      'active  color-1-100': _vm.activeSection === 'requiredEmails'
    }]
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 19.99 21"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 19.99 21",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0\n                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226\n                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657\n                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878\n                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995\n                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "10",
      "cy": "9.995",
      "r": "3"
    }
  })])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('requiredEmails')
      }
    }
  }, [_vm._v("Required emails")])]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['recommended']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 details",
    class: [{
      'active  color-1-100': _vm.activeSection === 'recommendedEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('recommendedEmails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 18"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 18",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12\n                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8\n                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1\n                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"
    }
  })])]), _vm._v(" "), (_vm.canEditRecommendedEmails === false) ? [_vm._v("Recommended emails")] : [_vm._v("Edit recommended emails")]], 2)]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['optional']) ? _c('div', {
    staticClass: "anchor-item anchor-item-custom color-1-20 password",
    class: [{
      'active  color-1-100': _vm.activeSection === 'optionalEmails'
    }]
  }, [_c('button', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToPageSection('optionalEmails')
      }
    }
  }, [_c('span', {
    staticClass: "anchor-item-icon color-1-40"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 20 20"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_1_",
      "d": "M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65\n                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"
    }
  })])]), _vm._v(" "), (_vm.canEditOptionalEmails === false) ? [_vm._v("Optional emails")] : [_vm._v("Edit optional emails")]], 2)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "content-left-section"
  }, [(_vm.emails && _vm.emails['required']) ? _c('div', {
    ref: "requiredEmails",
    staticClass: "content-section consent-section no-margin-top",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'requiredEmails'
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [_vm._v("Required emails")]), _vm._v(" "), _vm._l((_vm.emails['required']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox border-2-100-after",
      class: [{
        'is-locked': true
      }],
      attrs: {
        "type": "checkbox",
        "disabled": true,
        "checked": "checked",
        "data-lpignore": "true",
        "id": 'required-email-' + index.toLowerCase().replace(' ', '-')
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after",
      attrs: {
        "for": 'required-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        staticClass: "form-control form-control__checkbox border-2-100-after",
        class: [{
          'is-locked': true
        }],
        attrs: {
          "type": "checkbox",
          "disabled": true,
          "checked": "checked",
          "data-lpignore": "true",
          "id": 'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after",
        attrs: {
          "for": 'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['recommended']) ? _c('div', {
    ref: "recommendedEmails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'recommendedEmails' || _vm.canEditRecommendedEmails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "personal-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditRecommendedEmails === false) ? [_vm._v("Recommended emails")] : [_vm._v("Edit recommended emails")]], 2), _vm._v(" "), (_vm.canEditRecommendedEmails === false) ? _c('button', {
    staticClass: "edit-details edit-details-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditRecommendedEmails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails['recommended']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox border-2-100-after",
      class: [{
        'is-locked': !_vm.canEditRecommendedEmails
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.canEditRecommendedEmails,
        "data-lpignore": "true",
        "id": 'recommended-email-' + index.toLowerCase().replace(' ', '-')
      },
      domProps: {
        "checked": _vm.allChildrenAreChecked(category)
      },
      on: {
        "change": function($event) {
          return _vm.checkAllChildren($event, category)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      class: !_vm.canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
      attrs: {
        "for": 'recommended-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (email['checked']),
          expression: "email['checked']"
        }],
        staticClass: "form-control form-control__checkbox border-2-100-after",
        class: [{
          'is-locked': !_vm.canEditRecommendedEmails
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.canEditRecommendedEmails,
          "data-lpignore": "true",
          "id": 'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        },
        domProps: {
          "checked": Array.isArray(email['checked']) ? _vm._i(email['checked'], null) > -1 : (email['checked'])
        },
        on: {
          "change": function($event) {
            var $$a = email['checked'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(email, 'checked', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(email, 'checked', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(email, 'checked', $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63",
        class: !_vm.canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
        attrs: {
          "for": 'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.canEditRecommendedEmails) ? _c('div', {
    staticClass: "update-data update-data__details"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditRecommendedEmails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-details",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailPreferences('recommended')
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.emails && _vm.emails['optional']) ? _c('div', {
    ref: "optionalEmails",
    staticClass: "content-section profile-section",
    class: [{
      'content-section__bordered border-1-20': _vm.activeSection === 'optionalEmails' || _vm.canEditOptionalEmails
    }],
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('section', {
    staticClass: "password-info"
  }, [_c('h3', {
    staticClass: "content-section-title color-1-100 background-1-100-before"
  }, [(_vm.canEditOptionalEmails === false) ? [_vm._v("Optional emails")] : [_vm._v("Edit optional emails")]], 2), _vm._v(" "), (_vm.canEditOptionalEmails === false) ? _c('button', {
    staticClass: "edit-password edit-password-custom border-1-40 color-2-100",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openEditOptionalEmails()
      }
    }
  }, [_c('span', {
    staticClass: "edit-icon color-1-100"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 12.955 12.921"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 12.955 12.921",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "XMLID_1_"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_4_",
      "d": "M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921\n                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "id": "XMLID_5_",
      "d": "M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316\n                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0\n                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"
    }
  })])])]), _vm._v("\n                Edit\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.emails['optional']), function(category, index) {
    return [_c('div', {
      staticClass: "form-group__checkbox-block"
    }, [_c('div', {
      staticClass: "form-group form-group__checkbox"
    }, [_c('div', {
      staticClass: "form-element"
    }, [_c('input', {
      staticClass: "form-control form-control__checkbox",
      class: [{
        'is-locked': !_vm.canEditOptionalEmails
      }],
      attrs: {
        "type": "checkbox",
        "disabled": !_vm.canEditOptionalEmails,
        "data-lpignore": "true",
        "id": 'optional-email-' + index.toLowerCase().replace(' ', '-')
      },
      domProps: {
        "checked": _vm.allChildrenAreChecked(category)
      },
      on: {
        "change": function($event) {
          return _vm.checkAllChildren($event, category)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "form-label color-2-63",
      class: !_vm.canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
      attrs: {
        "for": 'optional-email-' + index.toLowerCase().replace(' ', '-')
      }
    }, [_vm._v(_vm._s(index))])])]), _vm._v(" "), _vm._l((category), function(email) {
      return [_c('div', {
        staticClass: "form-group form-group__checkbox form-group__checkbox-inside"
      }, [_c('div', {
        staticClass: "form-element"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (email['checked']),
          expression: "email['checked']"
        }],
        staticClass: "form-control form-control__checkbox",
        class: [{
          'is-locked': !_vm.canEditOptionalEmails
        }],
        attrs: {
          "type": "checkbox",
          "disabled": !_vm.canEditOptionalEmails,
          "data-lpignore": "true",
          "id": 'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        },
        domProps: {
          "checked": Array.isArray(email['checked']) ? _vm._i(email['checked'], null) > -1 : (email['checked'])
        },
        on: {
          "change": function($event) {
            var $$a = email['checked'],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(email, 'checked', $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(email, 'checked', $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(email, 'checked', $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        staticClass: "form-label color-2-63",
        class: !_vm.canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before',
        attrs: {
          "for": 'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']
        }
      }, [_vm._v("\n                          " + _vm._s(email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '')) + "\n                        ")])])])]
    })], 2)]
  }), _vm._v(" "), (_vm.canEditOptionalEmails) ? _c('div', {
    staticClass: "update-data update-data__password"
  }, [_c('button', {
    staticClass: "cancel-edit background-2-7 color-2-100 cancel-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closeEditOptionalEmails()
      }
    }
  }, [_vm._v("Discard changes")]), _vm._v(" "), _c('button', {
    staticClass: "save-edit background-1-100 color-2-100 save-edit-password",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateEmailPreferences('optional')
      }
    }
  }, [_vm._v("Save changes")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248f210c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/EmailPreferences.vue
// module id = 901
// module chunks = 1